module.exports = __webpack_public_path__ + "static/media/XL.e30134e0.jpg";